import { render, staticRenderFns } from "./DressDisplay.vue?vue&type=template&id=b8377fe0&scoped=true&"
import script from "./DressDisplay.vue?vue&type=script&lang=js&"
export * from "./DressDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DressDisplay.vue?vue&type=style&index=0&id=b8377fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8377fe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VProgressCircular,VRow})
